<template>
  <div class="plan-summary">
    <div class="plan-summary__row">
      <div>
        <div class="plan-summary__eyebrow">Selected plan</div>
        <div class="plan-summary__title">{{ plan.title }}</div>
      </div>
      <div class="plan-summary__price">
        <div v-if="coupon && due !== plan.price" class="plan-summary__strike">{{ formatPrice(plan.price) }}</div>
        <div class="plan-summary__due">{{ formatPrice(due) }}<span> / {{ plan.interval }}</span></div>
      </div>
    </div>
    <div class="plan-summary__links">
      <button type="button" class="pop-auth__link" data-test="change-plan" @click="$emit('change-plan')">Change plan</button>
      <button v-if="!couponOpen && !coupon && !affiliateOnly" type="button" class="pop-auth__link" @click="couponOpen = true">
        Have a promo code?
      </button>
      <span v-else-if="coupon" class="plan-summary__applied">{{ code }} applied. {{ describe }}</span>
      <span v-else-if="affiliateOnly" class="plan-summary__applied">Partner link applied</span>
    </div>
    <div v-if="couponOpen && !coupon" class="plan-summary__coupon">
      <input
        class="pop-auth__field plan-summary__coupon-input"
        :value="code"
        placeholder="Promo code"
        autofocus
        @input="$emit('update:code', $event.target.value.toUpperCase())"
        @keyup.enter="$emit('apply')"
      />
      <button type="button" class="pop-auth__btn pop-auth__btn--secondary plan-summary__apply" :disabled="code.length < 3 || busy" @click="$emit('apply')">
        {{ busy ? 'Checking' : 'Apply' }}
      </button>
    </div>
    <div v-if="error" class="pop-auth__err">{{ error }}</div>
  </div>
</template>

<script>
import { describeCoupon, discountedPrice } from './coupons'
import { formatPrice } from './plans'

// "Selected plan" card at the top of the signup page when the user arrives from the pricing
// page or a campaign. "Change plan" opens the Select a plan screen (/register/plans); the coupon
// is only previewed here, checkout applies it.
export default {
  name: 'PlanSummaryCard',
  props: {
    plan: { type: Object, required: true }, // selectedPlan() shape
    code: { type: String, default: '' },
    coupon: { type: Object, default: null },
    affiliateOnly: { type: Boolean, default: false },
    error: { type: String, default: '' },
    busy: { type: Boolean, default: false },
  },
  data() {
    return { couponOpen: Boolean(this.code) }
  },
  computed: {
    due() {
      return discountedPrice(this.plan.price, this.coupon)
    },
    describe() {
      return describeCoupon(this.coupon, this.plan.interval)
    },
  },
  methods: {
    formatPrice,
  },
}
</script>

<style scoped lang="scss">
@import './auth-tokens.scss';

.plan-summary {
  border: 1.5px solid $pop-accent-border;
  background: $pop-accent-bg;
  border-radius: 14px;
  padding: 14px 16px;
  margin-bottom: 24px;

  &__row { display: flex; justify-content: space-between; align-items: center; gap: 12px; }
  &__eyebrow { font-size: 11.5px; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; color: $pop-ink-muted; }
  &__title { font-family: 'Mulish', sans-serif; font-weight: 800; font-size: 18px; color: $pop-teal; margin-top: 2px; }
  &__price { text-align: right; }
  &__strike { font-size: 12.5px; color: $pop-ink-muted; text-decoration: line-through; }
  &__due { font-family: 'Mulish', sans-serif; font-weight: 800; font-size: 22px; color: $pop-accent; line-height: 1; }
  &__due span { font-size: 13px; font-weight: 600; color: $pop-ink-muted; }
  &__links { display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-top: 10px; font-size: 13px; flex-wrap: wrap; }
  &__applied { color: $pop-success; font-weight: 700; }
  &__coupon { display: flex; gap: 8px; margin-top: 12px; }
  &__coupon-input { flex: 1; padding: 11px 14px; font-size: 14px; }
  &__apply { width: auto; padding: 0 18px; font-size: 13.5px; }
}
</style>
